import { ApiError, ApiParameter } from "@insite/client-framework/Services/ApiService";

export interface pdfResultModel {
    result: any;
}

export interface DownloadPdfParameter extends ApiParameter {
    packagingSlipId?: string;
}

export const url = "/api/v2/report/packagingslip/";

export async function getPackagingSlipPdf(parameter: DownloadPdfParameter) {
    const response = await fetch(`${url}${parameter.packagingSlipId}`);

    try {
        const blob = response.ok && (await response.blob());
        if (!response.ok) {
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            );
        }
        return blob;
    } catch (error) {
        let message: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string; exceptionMessage?: string };
            message = errorJson.exceptionMessage ?? errorJson.message;
        } else {
            message = await response.text();
        }
        throw new ApiError(`${url}${parameter.packagingSlipId}`, response, message, errorJson);
    }
}
